import React from 'react';
import { Chip } from '@mui/material';
import useClasses from '../../../helpers/useClasses';


const styles = theme => ({
  root: {
    display: 'inline-block',
    borderRadius: '50%',
    flexGrow: 0,
    flexShrink: 0
  },
  suspicious_activity: {
    backgroundColor: '#C22121',
    color: '#ffffff'
  },
  slow_pay: {
    backgroundColor: '#BD8D46',
    color: '#ffffff'
  },
  split_payer: {
    backgroundColor: '#F57336',
    color: '#ffffff'
  },
  stacking_history: {
    backgroundColor: '#7F1367',
    color: '#ffffff'
  },
  default_account: {
    backgroundColor: '#04756F',
    color: '#ffffff'
  },
  default_satisfied: {
    backgroundColor: '#43a047',
    color: '#ffffff'
  },
  criminal_history: {
    backgroundColor: '#1E1E20',
    color: '#ffffff'
  },
  covid_hardship: {
    backgroundColor: '#ebc700',
    color: '#ffffff'
  },
  if_client_default: {
    backgroundColor: '#777777',
    color: '#ffffff'
  },
  if_vendor_slow_pay: {
    backgroundColor: '#999999',
    color: '#ffffff'
  },
  open_funding: {
    backgroundColor: '#cc5c9d',
    color: '#ffffff'
  },
  other: {
    backgroundColor: '#225378',
    color: '#ffffff'
  },
  merchant_dispute: {
    backgroundColor: '#111111',
    color: '#ffffff'
  }
});

const CategoryChip = props => {
  const { category } = props;

  const classes = useClasses(styles);

  let categoryClass = classes.default_account
  switch (category){
    case 'Suspicious Activity':
      categoryClass = {
        backgroundColor: '#C22121',
        color: '#ffffff'
      }
      break
    case 'Slow Pay':
      categoryClass = {
        backgroundColor: '#BD8D46',
        color: '#ffffff'
      }
      break
    case 'Open Funding':
      categoryClass = {
        backgroundColor: '#cc5c9d',
        color: '#ffffff'
      }
      break
    case 'Split Payer':
      categoryClass = {
        backgroundColor: '#F57336',
        color: '#ffffff'
      }
      break
    case 'Stacking History':
      categoryClass = {
        backgroundColor: '#7F1367',
        color: '#ffffff'
      }
      break
    case 'Default Account':
      categoryClass = {
        backgroundColor: '#04756F',
        color: '#ffffff'
      }
      break
    case 'Default/Slow Pay Satisfied':
      categoryClass = {
        backgroundColor: '#43a047',
        color: '#ffffff'
      }
      break
    case 'Criminal History':
      categoryClass = {
        backgroundColor: '#1E1E20',
        color: '#ffffff'
      }
      break
    case 'Covid-19 Hardship':
      categoryClass = {
        backgroundColor: '#ebc700',
        color: '#ffffff'
      }
      break
    case 'IF - Client Default':
      categoryClass = {
        backgroundColor: '#777777',
        color: '#ffffff'
      }
      break
    case 'IF - Vendor Slow/No Pay':
      categoryClass = {
        backgroundColor: '#999999',
        color: '#ffffff'
      }
      break
    case 'Other':
      categoryClass = {
        backgroundColor: '#225378',
        color: '#ffffff'
      }
      break
    case 'Merchant Dispute':
      categoryClass = {
        backgroundColor: '#111111',
        color: '#ffffff'
      }
      break
    default:
      categoryClass = {
        backgroundColor: '#04756F',
        color: '#ffffff'
      }
      break
  }

  return (
    <Chip sx={categoryClass} label={category} />
  );
};

export default CategoryChip;
